// Comment from Tochukwu
// The flyonUI should have provided an event that could have be subsubcribed
// to properly take other actions
// This is needed when programmatically using modal or dropdown from flyonUI
// its a global fix for pages where modal and dropdown were programmatically toggled

// Register instance FlyonUI Dropdown
/* global HSDropdown, HSOverlay */
(function init() {
    if (window.tailwind === undefined) window.tailwind = {};
    window.tailwind.Dropdown = {
        getInstance(el) {
            const { element } = HSDropdown.getInstance(el, true)
            return element
        },
        getOrCreateInstance(el) {
            if (el === null || el === undefined) {
                return null;
            }
            const { element } = HSDropdown.getInstance(el, true)
            return element
        },
    };
})();

(function init() {
    if (window.tailwind === undefined) window.tailwind = {};
    window.tailwind.Modal = {
        getInstance(el) {
            const { element } = HSOverlay.getInstance(el, true)
            return element
        },
        getOrCreateInstance(el) {
            if (el === null || el === undefined) {
                return null;
            }
            const { element } = HSOverlay.getInstance(el, true)
            return element
        },
    };
})();
